import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import WindowsSVG from '../../../assets/icons/clouds/windows.svg?raw';

export const WindowsLogo = (props) => <CustomSVG svg={WindowsSVG} preserveColors {...props} />;
